import { goto } from '$app/navigation';
import { getSupportedLanguagesAry } from '$lib/utilities/translate';

export const redirectToLangRoute = async (data) => {
	const url = new URL(window.location.href);
	const pathSegments = url.pathname.split('/');

	const { supportedLanguageAry, defaultLanguageCode } =
		getSupportedLanguagesAry();

	let newUrl;
	const current = `${url.pathname}${url.search}`;

	if (supportedLanguageAry.includes(pathSegments?.[1])) {
		console.log('path includes lang so go ahead');
		newUrl = current;
	} else {
		const lang = navigator.language;

		if (supportedLanguageAry.includes(lang)) {
			if (lang !== defaultLanguageCode) {
				console.log('navigator lang is not default');
				newUrl = `/${lang}${current}`;
			} else {
				console.log('default language code in navigator');
				newUrl = current;
			}
		} else {
			console.log('navigator lang not supported - using default');
			newUrl = current;
		}
	}

	if (newUrl === current) return false;

	await goto(newUrl, { replaceState: true });
	return true;
};
